<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span>News</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bInProgress" />

			@if( bAdmin ) {

				<button
					mat-raised-button
					routerLink="./bearbeiten"
				>
					<div class="iconAndTxt">
						<span class="material-icons">add</span>
						<span>Erstellung</span>
					</div>
				</button>

			}

		</div>

		<div class="newsColumn">

			@if( bError ) {
				<div class="errorWarning">
					Beim Abrufen der Nachrichten ist ein Fehler aufgetreten
				</div>
			}
			@else {

				<div class="filterLine">

					<mat-form-field
						subscriptSizing="dynamic"
						appearance="outline"
						style="width: 400px;"
					>
						<mat-label>Textsuche</mat-label>
						<input
							matInput
							[formControl]="txtCtrl"
						>
					</mat-form-field>

					@if( bAdmin ) {

						<mat-form-field
							subscriptSizing="dynamic"
							appearance="outline"
						>
							<mat-label>Freigabe</mat-label>
							<mat-select [formControl]="publicationCtrl">
								<mat-option value="">Alles</mat-option>
								<mat-option value="published">Freigegeben</mat-option>
								<mat-option value="unpublished">Nicht freigegeben</mat-option>
							</mat-select>
						</mat-form-field>
						
					}

					<mat-form-field
						subscriptSizing="dynamic"
						appearance="outline"
					>
						<mat-label>Zeitraum</mat-label>
						<mat-select [formControl]="periodCtrl">
							<mat-option value="">Alles</mat-option>
							<mat-option value="last30days">Letzte 30 Tage</mat-option>
							<mat-option value="last60days">Letzte 60 Tage</mat-option>
							<mat-option value="last180days">Letzte 180 Tage</mat-option>
							<mat-option value="last365days">Letzte 365 Tage</mat-option>
							@for( year of lastYears; track year ) {
								<mat-option value="{{year}}">{{year}}</mat-option>
							}
							<mat-option value="custom">Eigener Zeitraum</mat-option>
						</mat-select>
					</mat-form-field>

					@if( periodCtrl.value == "custom" ) {

						<mat-form-field
							subscriptSizing="dynamic"
							appearance="outline"
							style="max-width: 150px;"
						>
							<mat-label>Startdatum</mat-label>
							<input
								matInput
								[matDatepicker]="picker1"
								[formControl]="startDateCtrl"
								[max]="maxStartDate"
							>
							<mat-datepicker-toggle matIconSuffix [for]="picker1" />
							<mat-datepicker #picker1 />
						</mat-form-field>

						<mat-form-field
							subscriptSizing="dynamic"
							appearance="outline"
							style="max-width: 150px;"
						>
							<mat-label>Enddatum</mat-label>
							<input
								matInput
								[matDatepicker]="picker2"
								[formControl]="endDateCtrl"
								[min]="minEndDate"
							>
							<mat-datepicker-toggle matIconSuffix [for]="picker2" />
							<mat-datepicker #picker2 />
						</mat-form-field>

					}
					
				</div>

				@if( !shownRubrics.length && (!newsPerRubric[''] || !newsPerRubric[''].length) ) {
					<div class="noElements" style="text-align: center;">
						Keine Nachrichten
					</div>
				}
				@else {

					<div class="newsList">
	
						@for( rubric of shownRubrics; track rubric.id ) {
	
							<div class="rubric">
	
								<div
									(click)="bUnfolded[rubric.id] = !bUnfolded[rubric.id]"
									class="rubricName"
									[ngClass]="{ emptyRubric: (!newsPerRubric[rubric.id] || !newsPerRubric[rubric.id].length) }"
								>
				
									<span>
										{{rubric.name}}
									</span>
			
									@if( newsPerRubric[rubric.id] && newsPerRubric[rubric.id].length ) {
										<span class="numberOfNews">
											{{ newsPerRubric[rubric.id].length }}
										</span>
									}
			
								</div>
				
								@if( bUnfolded[rubric.id] && newsPerRubric[rubric.id] && newsPerRubric[rubric.id].length ) {
	
									<div class="newsBox">
										@for( oNews of newsPerRubric[rubric.id]; track oNews.id ) {
											<app-news-display [news]="oNews" />
										}
									</div>
	
								}
				
							</div>
	
						}
			
						@if( newsPerRubric[''] && newsPerRubric[''].length ) {
	
							<div class="rubric">
				
								<div
									(click)="bUnfolded[''] = !bUnfolded['']"
									class="rubricName"
								>
									<span>Ohne Rubrik</span>
			
									@if( newsPerRubric[''].length ) {
										<span class="numberOfNews">
											{{ newsPerRubric[''].length }}
										</span>
									}
			
								</div>
				
								@if( bUnfolded[''] && newsPerRubric[''] && newsPerRubric[''].length ) {
	
									<div class="newsBox">
	
										@for( oNews of newsPerRubric['']; track oNews.id ) {
											<app-news-display [news]="oNews" />
										}
										
									</div>
	
								}
				
							</div>
	
						}

						@if( currentPage || bMoreResults ) {
							<div class="paginationLine">
	
								@if( bInProgress ) {
									<mat-spinner diameter="20" />
								}
								@else {
									<span
										(click)="switchPage(-1)"
										title="Vorherige Nachrichten"
										class="material-icons pageIcon"
										[class.iconBtn]="currentPage"
										[class.iconDisabled]="!currentPage"
									>
										navigate_before
									</span>
	
									<span
										(click)="switchPage(+1)"
										title="Nächste Nachrichten"
										class="material-icons pageIcon"
										[class.iconBtn]="bMoreResults"
										[class.iconDisabled]="!bMoreResults"
									>
										navigate_next
									</span>
								}
	
							</div>
						}
	
					</div>

				}
	

			}

		</div>

	</div>

</div>

